<template>
  <div class="system-information">
    <chelyabinsk-info v-if="instance === `chelyabinsk`" />
    <default-info v-else />
  </div>
</template>

<script>
import defaultInfo from "./components/about-default";
import chelyabinskInfo from "./components/about-chelyabinsk";

export default {
  components: {
    defaultInfo,
    chelyabinskInfo
  },
  computed: {
    instance() {
      return this.$store.state.instance;
    }
  }
};
</script>

<style lang="scss"></style>

<i18n>
{
  "ru": {
  },
  "en": {
  }
}
</i18n>
